import { ROSQuestionnaire } from '../../../../../../lib/Questionnaires'
import { CheckboxInput, TextInput } from '../../../../../shared/FormBuilder'

function ENTE ({ disabled }) {
  return (
    <div className='row margin-top'>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteEpistaxis}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteTinnitus}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteDysphagia}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteSmellChanges}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteHearingChanges}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteTasteChanges}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteVisualChanges}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteDoubleVision}
        />
      </div>
      <div className='col-xs-12 margin-top'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.enteOther}
        />
      </div>
      <div className='col-xs-12'>
        <TextInput
          disabled={disabled}
          {...ROSQuestionnaire.enteOtherText}
        />
      </div>
    </div>
  )
}

export default ENTE
